<div
	class="
		text-white
		flex
		text-4xl
		items-center
		justify-center
		p-background-color-primary p-shadow
		rounded-l-full
		p-3
	"
>
	<i class="{{ attachmentIconClass }}"></i>
</div>
<div
	class="
		grid grid-cols-1
		p-border-color-component-colored-background p-shadow
		overflow-x-hidden
		w-full
	"
>
	<div class="flex-auto text-md leading-none font-medium break-words py-1 px-1">
		<ng-container *ngIf="visioSessionId; else attachmentName">
			{{ 'presentation.app.chat.message.attachment.visio.title' | translate }}
		</ng-container>
		<ng-template #attachmentName>{{ attachmentName$ | async }}</ng-template>
	</div>
	<div
		class="
			flex flex-auto flex-shrink-0 flex-grow-0 flex-row
			border-t
			justify-end
			p-border-color-primary
			border-solid border-0 border-t
		"
	>
		<button
			*ngIf="attachmentPath"
			[label]="'presentation.app.chat.message.attachment.open' | translate"
			[routerLink]="[attachmentPath]"
			class="p-button-primary-transparent"
			pButton
		></button>
		<button
			*ngIf="visioSessionId"
			[label]="'presentation.app.chat.message.attachment.visio.button' | translate"
			(click)="onOpenVisioClick(visioSessionId)"
			class="p-button-primary-transparent"
			pButton
		></button>
		<div class="relative">
			<div
				[class.flex]="isDownloading"
				[class.hidden]="!isDownloading"
				class="w-full h-full absolute items-center justify-center"
			>
				<p-progressSpinner styleClass="w-5 h-5"></p-progressSpinner>
			</div>
			<button
				*ngIf="attachmentUrl$ | async"
				[class.invisible]="isDownloading"
				[class.pointer-events-none]="isDownloading"
				[label]="'presentation.app.chat.message.attachment.download' | translate"
				(click)="onDownloadDocumentClick()"
				class="p-button-primary-transparent"
				pButton
			></button>
		</div>
		<button
			*ngIf="attachmentUrl$ | async"
			[label]="'presentation.app.chat.message.attachment.view' | translate"
			(click)="onShowDocumentClick()"
			class="p-button-primary-transparent"
			pButton
		></button>
	</div>
</div>
